<template>
  <div class="timeout container h-100 kanit">
    <div class="image-timeout">
        <img class="w-50" src="../../assets/images/error/errortimeout.png" alt="">
        <h2 class="header-text">ข้อความนี้หมดอายุ</h2>
        <p class="content-text">กรุณาทำรายการในบทสนทนาล่าสุด</p>
    </div>
    <div class="chat-bottom d-flex flex-column">
        <b-button variant="outline-line-primary" class="mt-2 hover-button-primary" block @click="closeTab">กลับสู่ Chat</b-button>
    </div>
  </div>
</template>

<script>
const context_line = JSON.parse(localStorage.getItem('context_line'))
export default {
    mounted() {
        this.$liff.init({
            liffId: context_line.liffId
        })
    },
    methods: {
        async closeTab() {
            await this.$liff.closeWindow();
        }
    }
}
</script>